import React, { useState, useEffect } from "react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function CustomDatePicker(props) {
  // eslint-disable-next-line no-unused-vars
  const [customShowTimeSelect, setCustomShowTimeSelect] = useState(
    props.customShowTimeSelect
  );

  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timeContainer = document.getElementsByClassName(
      "react-datepicker__time-container"
    );

    if (timeContainer.length > 0) {
      setReady(true);

      //console.log("READY!!!!");
    }
  }, [props]);

  const updateTimeSelector = () => {
    //console.log("IS READY?", ready);
    if (ready) {
      const timeContainer = document.getElementsByClassName(
        "react-datepicker__time-container"
      );

      let currentTimeContainerClass = "react-datepicker__time-container";

      if (timeContainer.length === 0) {
        currentTimeContainerClass = "newCalendarStyle";
      }

      const [currentContainer] = document.getElementsByClassName(
        currentTimeContainerClass
      );

      //console.log("currentTimeContainerClass", currentTimeContainerClass);

      //console.log("SHOW TIME...", props.customShowTimeSelect);

      const [reactDatepicker] =
        document.getElementsByClassName("react-datepicker");

      if (props.customShowTimeSelect) {
        //console.log("NO MOSTRAR", currentContainer);

        currentContainer.classList.add("newCalendarStyle");

        reactDatepicker.classList.add("borders_time_selector");
      } else {
        //console.log("MOSTRAR");
        currentContainer.classList.remove("newCalendarStyle");

        reactDatepicker.classList.remove("borders_time_selector");
      }
    }
  };

  useEffect(updateTimeSelector, [props, ready]);

  //console.log(customShowTimeSelect, "customShowTimeSelect");

  return <DatePicker {...props} />;
}
